import { type RowData, type TableFeature } from "@tanstack/react-table";

interface LoadMoreTableOptions<T> {
  onLoadMore?: (row: T) => void;
}

interface LoadMoreRowOptions<T> {
  loadMore: (row: T) => void;
}

declare module "@tanstack/react-table" {
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface TableOptionsResolved<TData extends RowData>
    extends LoadMoreTableOptions<TData> {}
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface Row<TData extends RowData> extends LoadMoreRowOptions<TData> {}
}

export const LoadMoreFeature: TableFeature = {
  createRow: (row, table): void => {
    row.loadMore = (value) => {
      table.options.onLoadMore?.(value);
    };
  },
};
